var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',{staticClass:"nav"},[_c('div',{staticClass:"nav-left"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":"logo"}}),_c('span',{staticClass:"brand",staticStyle:{"margin-left":"10px"}},[_vm._v("Echo-Trace")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }